import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Flame, Wrench, Thermometer, ShieldCheck, Phone, Droplets, ArrowRight } from 'lucide-react';
import { services } from '../data/services';
const iconMap = {
  Flame,
  Wrench,
  Thermometer,
  ShieldCheck,
  Phone,
  Droplets
};
export function Services() {
  return <section id="services" className="py-24 relative z-10 bg-[#0a0a0a]" data-id="element-229">
      <div className="max-w-7xl mx-auto px-6" data-id="element-230">
        <div className="text-center mb-16" data-id="element-231">
          <motion.span initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-[#FFD600] font-bold tracking-widest uppercase text-sm mb-4 block" data-id="element-232">
            Our Services
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-5xl font-black text-white" data-id="element-233">
            Complete Heating Solutions
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-234">
          {services.map((service, index) => {
          const Icon = iconMap[service.iconName];
          return <motion.div key={service.slug} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.08
          }} data-id="element-235">
                <Link to={`/services/${service.slug}`} className="group relative bg-brand-card rounded-2xl overflow-hidden border border-white/5 hover:border-[#FF9500]/30 transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_10px_40px_-10px_rgba(255,149,0,0.15)] block h-full" data-id="element-236">
                  <div className="aspect-video overflow-hidden bg-black" data-id="element-237">
                    <img src={service.heroImage} alt={service.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-238" />
                    <div className="absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-black/40 to-transparent pointer-events-none" data-id="element-239"></div>
                  </div>

                  <div className="p-7 relative" data-id="element-240">
                    <div className="absolute -top-7 left-7 w-14 h-14 rounded-full bg-gradient-primary p-[1px] shadow-lg" data-id="element-241">
                      <div className="w-full h-full bg-brand-card rounded-full flex items-center justify-center" data-id="element-242">
                        <Icon className="w-6 h-6 text-[#FF9500]" data-id="element-243" />
                      </div>
                    </div>
                    <div className="pt-8" data-id="element-244">
                      <h3 className="text-xl font-bold text-white mb-3" data-id="element-245">
                        {service.title}
                      </h3>
                      <p className="text-gray-400 mb-5 leading-relaxed text-sm" data-id="element-246">
                        {service.shortDescription}
                      </p>
                      <span className="inline-flex items-center gap-2 text-[#FFD600] font-semibold text-sm group-hover:gap-3 transition-all" data-id="element-247">
                        Learn more <ArrowRight className="w-4 h-4" data-id="element-248" />
                      </span>
                    </div>
                  </div>
                </Link>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}